import { Laptop, Camera, Fingerprint, Package, TrendingUp, Users } from 'lucide-react';

const statsData = [
  {
    id: 'total-products',
    label: 'Total Products',
    value: '0',
    icon: Package,
    color: 'bg-blue-500',
  },
  {
    id: 'laptops',
    label: 'Laptops',
    value: '0',
    icon: Laptop,
    color: 'bg-orange-500',
  },
  {
    id: 'cctv',
    label: 'CCTV Cameras',
    value: '0',
    icon: Camera,
    color: 'bg-green-500',
  },
  {
    id: 'biometrics',
    label: 'Biometrics',
    value: '0',
    icon: Fingerprint,
    color: 'bg-purple-500',
  },
];

export const Dashboard = () => {
  return (
    <div data-testid="dashboard-page">
      {/* Page Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900 uppercase tracking-tight">Dashboard</h1>
        <p className="text-slate-600 mt-1">Welcome to Tejas Info Solutions Inventory Management</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {statsData.map((stat) => {
          const Icon = stat.icon;
          return (
            <div
              key={stat.id}
              data-testid={`stat-${stat.id}`}
              className="bg-white rounded-sm border border-slate-200 p-6 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${stat.color} rounded-sm flex items-center justify-center`}>
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <TrendingUp className="h-5 w-5 text-green-500" />
              </div>
              <div className="text-3xl font-bold text-slate-900 mb-1">{stat.value}</div>
              <div className="text-slate-600 text-sm">{stat.label}</div>
            </div>
          );
        })}
      </div>

      {/* Quick Info Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Recent Activity */}
        <div className="bg-white rounded-sm border border-slate-200 p-6">
          <h2 className="text-xl font-bold text-slate-900 mb-4 uppercase tracking-tight">Recent Activity</h2>
          <div className="text-center py-12 text-slate-400">
            <Package className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>No recent activity</p>
            <p className="text-sm">Start by adding products in Master Data</p>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="bg-white rounded-sm border border-slate-200 p-6">
          <h2 className="text-xl font-bold text-slate-900 mb-4 uppercase tracking-tight">Quick Actions</h2>
          <div className="space-y-3">
            <button
              data-testid="quick-add-product"
              className="w-full flex items-center gap-3 px-4 py-3 bg-slate-50 hover:bg-slate-100 rounded-sm transition-colors text-left"
            >
              <Package className="h-5 w-5 text-orange-500" />
              <span className="text-slate-700 font-medium">Add New Product</span>
            </button>
            <button
              data-testid="quick-view-inventory"
              className="w-full flex items-center gap-3 px-4 py-3 bg-slate-50 hover:bg-slate-100 rounded-sm transition-colors text-left"
            >
              <Users className="h-5 w-5 text-orange-500" />
              <span className="text-slate-700 font-medium">View All Inventory</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
